var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';
import { Button } from '@appspotr/ui-kit';
import { Container, ContentContainer, InnerContainer, ButtonContainer, PrivacyPolicyLink, } from './styles';
import { shouldShow } from '../../../utils/analytics';
var ANALYTICS_ANSWER_KEY = 'APT_ANALYTICS_ANSWER_KEY';
var ANALYTICS_CONSENT_KEY = 'APT_ANALYTICS_CONSENT_KEY';
var enableAnalytics = function () {
    // Hotjar instantiation
    var hotjarId = parseInt(process.env.HOTJAR_ID || '');
    var hotjarVersion = parseInt(process.env.HOTJAR_V || '');
    if (!isNaN(hotjarId) && !isNaN(hotjarVersion)) {
        hotjar.initialize(hotjarId, hotjarVersion);
    }
    ///////////////////////
    // GTM instantiation
    var gtmId = process.env.GTM_ID || '';
    if (gtmId !== '') {
        var tagManagerArgs = {
            gtmId: gtmId,
        };
        TagManager.initialize(tagManagerArgs);
    }
    ////////////////////
};
var AnalyticsBar = function (_a) {
    var _b = _a.locationPath, locationPath = _b === void 0 ? '' : _b;
    var _c = useState(false), show = _c[0], setShow = _c[1];
    useEffect(function () {
        var hasAnswered = localStorage.getItem(ANALYTICS_ANSWER_KEY);
        if (!hasAnswered && shouldShow(locationPath)) {
            setShow(true);
        }
        else {
            setShow(false);
        }
    }, [locationPath]);
    useEffect(function () {
        var hasAnswered = localStorage.getItem(ANALYTICS_ANSWER_KEY);
        var hasConsented = localStorage.getItem(ANALYTICS_CONSENT_KEY);
        if (hasAnswered === 'true' && hasConsented === 'true') {
            enableAnalytics();
        }
        else {
            if (!shouldShow(locationPath)) {
                enableAnalytics();
            }
        }
    }, [locationPath]);
    var handleDeny = function () {
        localStorage.setItem(ANALYTICS_ANSWER_KEY, 'true');
        localStorage.setItem(ANALYTICS_CONSENT_KEY, 'false');
        setShow(false);
    };
    var handleAccept = function () {
        localStorage.setItem(ANALYTICS_ANSWER_KEY, 'true');
        localStorage.setItem(ANALYTICS_CONSENT_KEY, 'true');
        enableAnalytics();
        setShow(false);
    };
    if (!show) {
        return null;
    }
    return (_jsx(Container, { children: _jsxs(InnerContainer, { children: [_jsxs(ContentContainer, { children: ["By clicking ", _jsx("b", { children: "\"Accept\"" }), ", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts. View our", ' ', _jsx(PrivacyPolicyLink, __assign({ target: "apt-privacy-policy", href: "https://assets.website-files.com/5e6c676175d1aeb1a59777f4/5f9fee1d1354f7f9055a22c0_Appspotr_Privacy%20Policy.pdf" }, { children: "Privacy Policy" })), ' ', "for more information."] }), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ type: "outline", onClick: handleDeny }, { children: "Deny" })), _jsx("div", { style: { padding: 10 } }), _jsx(Button, __assign({ type: "primary", onClick: handleAccept }, { children: "Accept" }))] })] }) }));
};
export default AnalyticsBar;
